import React, { memo, MouseEvent, ReactNode } from 'react';
import { Link } from 'react-router';

export interface CustomLinkProps extends React.HTMLAttributes<HTMLElement> {
	to?: string;
	children?: ReactNode;
	className?: string;
	onClick?: (event: MouseEvent<HTMLElement> | MouseEvent<HTMLAnchorElement>) => void;
	linkOutside?: boolean;
	target?: string;
}

const CustomLink = ({
	to,
	children,
	className,
	onClick = () => {},
	linkOutside = false,
	target,
	...rest
}: CustomLinkProps) => {
	if (linkOutside) {
		return (
			<a
				href={to}
				target={target || '_blank'}
				rel="noopener noreferrer"
				className={className}
				onClick={onClick as React.MouseEventHandler<HTMLAnchorElement>}
				{...rest}
			>
				{children}
			</a>
		);
	}
	if (to && !linkOutside) {
		return (
			<Link
				to={to}
				className={className}
				onClick={onClick as React.MouseEventHandler<HTMLAnchorElement>}
				target={target}
				{...rest}
			>
				{children}
			</Link>
		);
	}
	return (
		<button className={className} onClick={onClick} {...rest}>
			{children}
		</button>
	);
};

export default memo(CustomLink);
